import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'store'

// /**
//  * Hook używany do dodawania tekstów na stronę.
//  * Jeśli teksty nie zostaną pobrane z mongo, oznacza to błąd i kierujemy użytkownika na stronę z błędem.
//  * 
//  * Funkcja zwracana przez hook, daje znam możliwość odwoływania się do kolejnych struktur zwracanego JSONa za pomocą operatora: ".".

//  * @returns {Func}
//  */
const useTextContents = (): (( path: string ) => string)  =>  {
   const textContentsFromBackend = useSelector((state: AppState) => state.textContentsState)

   const getTextContents = useCallback(( path: string ): string => {
      const keys = path.split('.')
      let result: any = textContentsFromBackend

      for (const key of keys) {
         // Check for invalid characters
         if (result && typeof result === 'object' && key in result) {
           result = result[key]
         } 
         else {
           console.warn(`Key not found: ${key}`)
           return ''
         }
      }

      return typeof result === 'string' ? result : ""
   }, [textContentsFromBackend])

   return getTextContents
}

export default useTextContents